<template>
  <v-app>
    <v-main>
      <router-view></router-view>
    </v-main>

    <!-- Snackbar globale per i messaggi di errore dell'interceptor axios
         (services/interceptor.js) — copre anche la pagina di login, non solo
         le view autenticate dentro Main.vue. -->
    <v-snackbar :model-value="snackbar.show" @update:model-value="chiudiSnackbar" :color="snackbar.color"
      timeout="5000" location="bottom">
      {{ snackbar.text }}
      <template #actions>
        <v-btn variant="text" @click="chiudiSnackbar(false)">Chiudi</v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>

<script>
export default {
  name: "App",

  computed: {
    snackbar() {
      return this.$store.state.app.snackbar;
    },
  },

  methods: {
    // v-snackbar emette update:model-value sia aprendo che chiudendo: va
    // nascosto solo quando il nuovo valore è false, altrimenti lo snackbar si
    // richiudeva subito da solo appena aperto (mai visibile).
    chiudiSnackbar(valore) {
      if (!valore) this.$store.commit("app/HIDE_MESSAGE");
    },
  },
};
</script>
